import CircularProgress from '@mui/material/CircularProgress';
import './LoadingScreen.style.scss';
import { useTranslation } from 'react-i18next';

const LoadingScreen = ({ text = undefined, open }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="backdrop-loading">
      <div className="loading">
        <CircularProgress color="inherit" />
        <span>{text ?? t('loaders.defaultLoadingText')}</span>
      </div>
    </div>
  );
};

export default LoadingScreen;
